import { useTenant } from "hooks/settings";
import { useUpdateAndDeployPlanResultsMutation } from "src/store/api/generatedApi";
import { useAppDispatch } from "src/store/store";
import { handleOnSubmit } from "./utils";
import { useMemo } from "react";
import { minimumPeriod } from "hooks/periodIndex";
import { PlanId } from "components/common/boundary/PlanId";
import { CoreDeploymentType } from "components/common/plan/types";

export const useHandleOnSubmit = (
  startAt: Date,
  endAt: Date,
  planId: PlanId,
  deploymentType: CoreDeploymentType
) => {
  const dispatch = useAppDispatch();
  const tenantName = useTenant();
  const [mutation] = useUpdateAndDeployPlanResultsMutation();
  const period = minimumPeriod;
  const callback = useMemo(() => {
    return handleOnSubmit(
      dispatch,
      tenantName,
      startAt,
      endAt,
      planId,
      period,
      deploymentType,
      mutation
    );
  }, [
    dispatch,
    tenantName,
    startAt,
    endAt,
    planId,
    mutation,
    period,
    deploymentType,
  ]);

  return callback;
};
